/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatalistAnagrafica, LeggiProgetto } from '@models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';
import { CurrencyMaskInputMode } from 'ngx-currency';

@Component({
    selector: 'app-toolkit-modal-leggi-progetto',
    templateUrl: './modal-leggi-progetto.component.html',
})
export class ToolkitGestioneProgettoModalLeggiProgettoComponent implements OnInit {
    
    @Input() canEdit: boolean;
    @Input() azione: string;
    @Input() datalist: DatalistAnagrafica;
    @Input() params: LeggiProgetto;

    readonly natural = CurrencyMaskInputMode.NATURAL;
    public criteriaForm: FormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private progettoService: ProgettoService,
        private fb: FormBuilder,
        private utilsService: UtilsService
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            idLeggeProgetto: this.fb.control(null),
            idProgetto: this.fb.control(this.progettoService.progettoSession.idProgetto, Validators.required),
            importoFinanziatoEuro: this.fb.control(null),
            annoFinanziamento: this.fb.control(null, [Validators.pattern('^(19|20)[0-9]{2}$')]),
            annoFineLavori: this.fb.control(null, [Validators.pattern('^(19|20)[0-9]{2}$')]),
            programma: this.fb.control(null),
            idLegge: this.fb.control(null)
        });
        if (this.params) {
            this.criteriaForm.patchValue(this.params);
        }
        if (!this.canEdit) {
            this.criteriaForm.disable();
        }
    }

    public save() {
        if(this.criteriaForm.get('annoFinanziamento')?.invalid) {
            this.utilsService.showWarning('Inserire un anno valido compreso tra il 1900 e il 2099 (Anno finanziamento)');
            return;
        } else  if(this.criteriaForm.get('annoFineLavori')?.invalid) {
            this.utilsService.showWarning('Inserire un anno valido compreso tra il 1900 e il 2099 (Anno fine lavori)');
            return;
        }
        
        this.activeModal.close(this.criteriaForm);
    }

}
